import React, { useEffect, useState } from 'react';
import {
  getBusinessArea,
  getCurrentFile,
  getService,
  setCurrentFile,
  setRegenerateExtraction,
  useAppDispatch,
  useAppSelector
} from 'app/redux';
import styles from './CatastropheDeletection.module.scss';
import { Chip, LoadingSpinner, ServiceOptions } from 'app/components';
import { processFileAndGetAnomalies } from 'integration/claims/catastropheDetection';
import { UploadedFileCard } from '../UploadedDocument/UploadedDocument';
import { ActionButtons } from 'app/components/ActionButtons/ActionButtons';
import { notify } from '@zurich-base-ui/components.toast';
import RegionSelector from './RegionSelector';

export const CatastropheDetection: React.FC = () => {
  const dispatch = useAppDispatch();
  const currentService = useAppSelector(getService);
  const currentBusinessArea = useAppSelector(getBusinessArea);
  const currentFile = useAppSelector(getCurrentFile);

  const [datasetsLoading, setDatasetsLoading] = useState<boolean>(false);
  const [keywords, setKeywords] = useState<string>('');
  const [antiKeywords, setAntiKeywords] = useState<string>('');
  const [selectedRegion, setSelectedRegion] = useState<string>('');

  useEffect(() => {
    dispatch(setRegenerateExtraction(null));
  }, [currentBusinessArea, currentService]);

  const handleUpload = async () => {
    setDatasetsLoading(true);
    try {
      const result = await processFileAndGetAnomalies(
        String(currentBusinessArea),
        String(currentService),
        String(selectedRegion),
        currentFile!,
        keywords,
        antiKeywords
      );

      if (result.kind === 'no-anomalies') {
        notify({ type: 'success', message: result.message });
        return;
      }

      const { file: excelBlob, fileName } = result;

      const link = document.createElement('a');
      link.href = URL.createObjectURL(excelBlob);
      link.download = fileName;
      link.click();
    } catch (e) {
      console.error(e);
    } finally {
      setDatasetsLoading(false);
    }
  };

  const handleEraseDocument = (): void => {
    dispatch(setCurrentFile(undefined));
  };

  const handleKeywordChange = (
    e: React.ChangeEvent<HTMLTextAreaElement>
  ): void => {
    setKeywords(e.target.value);
  };

  const handleAntiKeywordChange = (
    e: React.ChangeEvent<HTMLTextAreaElement>
  ): void => {
    setAntiKeywords(e.target.value);
  };

  const handleOnRegionChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ): void => {
    console.log(e.target.value);
    setSelectedRegion(e.target.value);
  };

  return (
    <div className={styles['service-container']}>
      {datasetsLoading && <LoadingSpinner />}
      <div className={styles['service-options']}>
        <ServiceOptions />
        <RegionSelector handleOnRegionChange={handleOnRegionChange} />
      </div>

      <br />

      <div>
        <ActionButtons
          handleDelete={handleEraseDocument}
          showUploadNewFile={true}
        />
        {currentFile && <UploadedFileCard file={currentFile} />}
      </div>

      <div className={styles['catia-table']}>
        <h2>Key Words to Include</h2>
        <textarea
          placeholder="Comma separated Keywords ie: hurricane, flood, earthquake"
          onChange={handleKeywordChange}
        />

        <h2>Key Words to Exclude</h2>
        <textarea
          placeholder="Comma separated Keywords ie: hurricane, flood, earthquake"
          onChange={handleAntiKeywordChange}
        />

        <Chip
          value={`Get Results`}
          id={`getResults`}
          selected={!!currentFile && !!selectedRegion}
          disabled={!currentFile || !selectedRegion}
          onClick={handleUpload}
        />
      </div>
    </div>
  );
};
